import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Title } from '@nerdwallet/react-typography';
import Link from '@nerdwallet/react-link';
import Image from '@nerdwallet/react-image';

import { stringInputSpec, titleInput } from '../../lib/editing-configs';

import styles from './story-block.module.less';

const StoryBlockStory = ({ title, linkUrl, previewImg }) => (
  <li className={styles['story-block-story__cont']}>
    {previewImg ? (
      <Link href={linkUrl} target="_blank">
        <Image
          className={styles['story-block-image__cont']}
          src={previewImg}
          objectFit="cover"
          objectPosition="center"
          alt={title}
        >
          <div className={styles['story-block-image__overlay']} />
        </Image>
      </Link>
    ) : null}
    <div className={styles['story-block-body__cont']}>
      <Link href={linkUrl} color="neutral-darkest" target="_blank">
        <Title size="small" className={styles['story-block-title']}>
          {title}
        </Title>
      </Link>
    </div>
  </li>
);

StoryBlockStory.displayName = 'StoryBlockStory';

StoryBlockStory.propTypes = {
  title: PropTypes.string,
  linkUrl: PropTypes.string,
  previewImg: PropTypes.string,
};

StoryBlockStory.defaultProps = {
  title: '',
  linkUrl: '',
  previewImg: '',
};

StoryBlockStory.getEditingConfig = () => [
  titleInput,
  stringInputSpec('linkUrl', 'URL of story'),
  stringInputSpec('previewImg', 'Preview image URL'),
];

export default StoryBlockStory;
